export default {
  error: {
    error_occured: "Ha habido un error",
    reload_page: "Recargar la página",
    back: "Retroceder",
    message: {
      not_found: "La página que ha solicitado no se encuentra.",
      unavailable: "Servicio no disponible",
      not_authorized_title: "Acceso prohibido",
      not_authorized: "No tiene permiso para acceder a esta página",
      file_not_authorized: "No está autorizado a descargar un archivo",
      unauthenticated: "Debe autenticarse para acceder a esta página",
    },
    go_back_to_home: "Volver al principio",
    support_message:
      "Se ha producido un error durante la operación que ha intentado realizar. Nuestros equipos están al tanto y trabajando para resolverlo. Gracias por su comprensión.",
    login_attempts:
      "Te quedan {attempts} intentos. Si superas ese límite, tu acceso quedará suspendido durante 5 minutos por motivos de seguridad.",
    login_blocked:
      "Tu cuenta ha sido bloqueada temporalmente tras varios intentos fallidos. Espera 5 minutos antes de volver a intentarlo.",
  },
  warning: {
    title: "Attention : ",
  },
};
